export enum InvoiceColumnEnum {
    INVOICE_REFERENCE = 'INVOICE_REFERENCE',
    INVOICE_DATE = 'INVOICE_DATE',
    INVOICE_TOTAL = 'INVOICE_TOTAL',
    INVOICE_TOTAL_NET = 'INVOICE_TOTAL_NET'
}
